/* The theme handles catalog filters, sorting and pagination. Enhancements stay within this collection template. */
(() => {
  if (!customElements.get('laguna-collection-description')) {
    // The native range step can be 65, which incorrectly marks a typed $300 as invalid.
    // Keep slider increments while allowing whole currency amounts in the text fields.
    const preparePriceInputs = () => {
      if (!document.querySelector('.laguna-collection-main')) return;
      document.querySelectorAll('.laguna-collection-main price-range input[type="number"], .facet-drawer price-range input[type="number"]').forEach(input => { input.step = '1'; });
    };
    preparePriceInputs();
    document.addEventListener('DOMContentLoaded', preparePriceInputs, {once:true});
    document.addEventListener('collection:reloaded', preparePriceInputs);
    document.addEventListener('shopify:section:load', preparePriceInputs);
    customElements.define('laguna-collection-description', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort(); this.abort = new AbortController();
        this.content = this.querySelector('[data-content]'); this.button = this.querySelector('button');
        if (!this.content || !this.button) return;
        this.expanded = false; this.content.classList.add('is-collapsed');
        this.button.addEventListener('click', () => {
          this.expanded = !this.expanded;
          this.content.classList.toggle('is-collapsed', !this.expanded);
          this.button.setAttribute('aria-expanded', String(this.expanded));
          this.button.textContent = this.expanded ? this.dataset.less : this.dataset.more;
        }, {signal:this.abort.signal});
        this.resize = new ResizeObserver(() => { if (!this.expanded) this.button.hidden = this.content.scrollHeight <= this.content.clientHeight + 1; });
        this.resize.observe(this.content);
      }
      disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); }
    });
  }
  if (!customElements.get('laguna-collection-navigation')) {
    customElements.define('laguna-collection-navigation', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort(); this.abort = new AbortController(); const opts = {signal:this.abort.signal};
        this.track = this.querySelector('[data-track]'); if (!this.track) return;
        this.prev = this.querySelector('[data-prev]'); this.next = this.querySelector('[data-next]');
        this.prev.addEventListener('click', () => this.move(-1), opts);
        this.next.addEventListener('click', () => this.move(1), opts);
        this.track.addEventListener('scroll', () => this.update(), {...opts,passive:true});
        this.track.addEventListener('keydown', e => {if(e.target===this.track && ['ArrowLeft','ArrowRight'].includes(e.key)){e.preventDefault();this.move(e.key==='ArrowRight'?1:-1);}},opts);
        document.addEventListener('shopify:block:select', e => {
          const item = [...this.querySelectorAll('[data-block-id]')].find(b => b.dataset.blockId === e.detail.blockId);
          if (item) this.track.scrollTo({left:item.offsetLeft-this.track.offsetLeft,behavior:'instant'});
        },opts);
        this.resize = new ResizeObserver(() => this.update()); this.resize.observe(this.track); this.update();
      }
      move(direction) { this.track.scrollBy({left:direction*this.track.clientWidth*.75,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}); }
      update() {this.prev.disabled=this.track.scrollLeft<2;this.next.disabled=this.track.scrollLeft>=this.track.scrollWidth-this.track.clientWidth-2;}
      disconnectedCallback() {this.abort?.abort();this.resize?.disconnect();}
    });
  }
})();
